<template>
    <div class="row" v-on="$listeners">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "VRow"
};
</script>